import { useString as s } from "../../../../components/StringProvider";
import Text from "../../../../components/Text";
import { message } from "antd";
import NewButton from "../../../../components/NewButton";
import styled from "styled-components";
import PropTypes from "prop-types";
import { selectRequestState } from "../../../../store/reducers";
import { bindActionCreators, compose } from "redux";
import { connect } from "react-redux";
import { deleteSalesforceConfiguration } from "../../../../store/actions/config";
import types from "../../../../store/actionTypes";
import useLoadingState from "../../../../utils/use-loading-state";
import ButtonGroup from "../../../../components/ButtonGroup";
import { Modal } from "../../../../components";

const DisconnectSalesforceModal = ({
  deleteSalesforceConfiguration,
  deleteLoadingState,
  onClose
}) => {
  const deleteError = s(
    "disconnectSalesforce.popup.messages.deleteError",
    "Failed to disconnect"
  );
  const header = s(
    "disconnectSalesforce.popup.header",
    "Disconnect Salesforce"
  );
  const subheader = s(
    "disconnectSalesforce.popup.subheader",
    "Do you want to disconnect from Salesforce and delete your settings?"
  );
  const ok = s("disconnectSalesforce.popup.ok.label", "Yes, disconnect");
  const cancel = s("disconnectSalesforce.popup.cancel.label", "Keep as it is");

  useLoadingState(
    deleteLoadingState,
    () => {
      onClose();
    },
    () => {
      message.error(deleteError);
    }
  );

  const onDisconnect = async () => {
    deleteSalesforceConfiguration();
  };

  return (
    <Modal title={header} open={true} onCancel={onClose}>
      <WarningText>
        <Text>{subheader}</Text>
      </WarningText>
      <ButtonGroup>
        <NewButton type={"primary"} onClick={onDisconnect}>
          {ok}
        </NewButton>
        <NewButton type={"secondary"} onClick={onClose}>
          {cancel}
        </NewButton>
      </ButtonGroup>
    </Modal>
  );
};

const WarningText = styled.div`
  margin-bottom: 16px;
`;

DisconnectSalesforceModal.propTypes = {
  onClose: PropTypes.func.isRequired
};

const mapStateToProps = (state) => ({
  deleteLoadingState: selectRequestState(
    state,
    types.DELETE_SALESFORCE_CONFIGURATION_REQUEST
  )
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      deleteSalesforceConfiguration
    },
    dispatch
  );

export default compose(connect(mapStateToProps, mapDispatchToProps))(
  DisconnectSalesforceModal
);
